var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-row customize-editor-minimize" },
    [
      _c("div", { staticClass: "editor-row-title" }, [_vm._v("Region Code")]),
      _vm._v(" "),
      _c(
        "a-select",
        {
          staticStyle: { width: "100%" },
          model: {
            value: _vm.clone.extract_phone_number.regionCode,
            callback: function ($$v) {
              _vm.$set(_vm.clone.extract_phone_number, "regionCode", $$v)
            },
            expression: "clone.extract_phone_number.regionCode",
          },
        },
        [
          _c("a-select-option", { attrs: { value: "TR" } }, [
            _vm._v("Türkiye (TR)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "US" } }, [
            _vm._v("United States (US)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "GB" } }, [
            _vm._v("United Kingdom (GB)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "DE" } }, [
            _vm._v("Germany (DE)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "FR" } }, [
            _vm._v("France (FR)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "RU" } }, [
            _vm._v("Russia (RU)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "IN" } }, [
            _vm._v("India (IN)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "CN" } }, [
            _vm._v("China (CN)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "JP" } }, [
            _vm._v("Japan (JP)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "KR" } }, [
            _vm._v("South Korea (KR)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "BR" } }, [
            _vm._v("Brazil (BR)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "AU" } }, [
            _vm._v("Australia (AU)"),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "CA" } }, [
            _vm._v("Canada (CA)"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("small", { staticClass: "description" }, [
        _vm._v(
          "\n        Select the region code to improve phone number detection\n    "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }